import "../styles.scss";
import React from "react";
import PropTypes from "prop-types";
import { getIn } from "formik";
import _ from "lodash";
import { createClassNameString } from "../../utils";
import { FormFieldError } from "../FormFieldError/FormFieldError";
import NumberFormat from "react-number-format";

// copied from src\components\Common\FormHelpers\FormikNumberInput.js
const phoneNumberFormat = (val) => {
  let mainVal;
  let firstNumber = val.substring(0, 3);
  let middleNumber = val.substring(3, 6);
  let lastNumber = val.substring(6, 10);
  if (firstNumber.length) {
    mainVal = `(${firstNumber})`;
  }
  if (firstNumber.length && middleNumber.length) {
    mainVal = `(${firstNumber}) ${middleNumber}`;
  }
  if (firstNumber.length && middleNumber.length && lastNumber.length) {
    mainVal = `(${firstNumber}) ${middleNumber}-${lastNumber}`;
  }
  return mainVal;
};

export const FormPhoneNumberField = ({
  name,
  title,
  subTitle,
  placeholder,
  customError,
  className,
  formikProps,
  // normally form fields do not error until after submission
  // because they have not been touched
  // setting this to true triggers the error after editing
  // for the first time
  triggerErrorOnChange = false,
  ...props
}) => {
  const errorMessage = getIn(formikProps.errors, name);
  const isTouched = getIn(formikProps.touched, name);
  const value = _.get(formikProps.values, name);

  const handleChange = async (event) => {
    await formikProps.setFieldValue(name, event.value);
    if (!isTouched && triggerErrorOnChange) {
      await formikProps.setFieldTouched(name, true);
    }
  };

  return (
    <div className={createClassNameString(["FormField-container", className])}>
      {(title || subTitle) && (
        <div data-public className="FormField-header_container">
          {title && <h3 className="FormField-title">{title}</h3>}
          {subTitle && <h3 className="FormField-subTitle">{subTitle}</h3>}
        </div>
      )}
      <div>
        <NumberFormat
          format={phoneNumberFormat}
          className={createClassNameString([
            "apti-CL apti-Input FormTextInput-input",
            isTouched && errorMessage && "error",
          ])}
          placeholder={placeholder}
          onValueChange={handleChange}
          value={value}
          {...props}
        />
        {!customError && errorMessage && isTouched && (
          <FormFieldError>{errorMessage}</FormFieldError>
        )}
        {/* lets the dev pick what is displayed below the text area */}
        {customError && customError(value, errorMessage, isTouched)}
      </div>
    </div>
  );
};

FormPhoneNumberField.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  customError: PropTypes.func,
  formikProps: PropTypes.object,
  triggerErrorOnChange: PropTypes.bool,
};
